"use strict"

$(document).on("turbolinks:load", function() {
  activate_show_analogs_modal_close()
})

function activate_show_analogs_modal_close() {
  $("body").on("click", ".show_analogs_modal-close", function(event) {
    var close = $(this)
    var show_analogs_modal = close.parent().parent()
    show_analogs_modal.addClass("show_analogs_modal-hidden")
  })
}
